<template>
  <button class="w-7 right-2" @click.stop="$emit('click')" title="更多">
    <i class="fa fa-ellipsis-v"></i>
  </button>
</template>

<script>
export default {};
</script>